export default {"src":"/_next/static/media/health-cross.01476b5a.svg","height":50,"width":49};